module.exports = __webpack_public_path__ + "static/img/QLD-11.4bfa64c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-11.jpg
// module id = a3Yp
// module chunks = 0